// Capacitor
import { registerPlugin } from '@capacitor/core'

const BinnacleGeo = registerPlugin('BinnacleGeo')

export { BinnacleGeo }
